import { Box } from '@podiumhq/design-system';

import { CheckoutPageHeader } from './CheckoutPageHeader';

export const CheckoutPageWrapper = ({
  children,
  closeCheckoutPage,
  displayHeader,
  isMobile,
}) => {
  const shouldDisplayHeader = displayHeader || closeCheckoutPage;

  return (
    <>
      {shouldDisplayHeader && (
        <CheckoutPageHeader closeCheckoutPage={closeCheckoutPage} />
      )}

      <Box
        margin={shouldDisplayHeader ? '88px auto 0 auto' : '0 auto'}
        maxWidth="1440px"
        padding={isMobile ? '24px' : '20px 40px 24px 40px'}
      >
        {children}
      </Box>
    </>
  );
};
